import Typography from '@mui/joy/Typography'

export const Copyright = () => (
    <>
        <Typography level="body-xs">
            © {new Date().getFullYear()} Bruce Technologies, Inc.{' '}
        </Typography>
    </>
)
